<template>
  <div class="home-box">
    <PageTitle :title="'Stock Adjustment'" class="py-5"></PageTitle>
    <v-card class="pa-5">
      <v-tabs v-model="tab" background-color="#f5f5f5" grow class="tab">
        <v-tab class="tab"> Add Stock </v-tab>
        <v-tab class="tab"> Deduct Stock </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <StockAdjustmentFormADD :adjustmentType="'Add'" />
        </v-tab-item>
        <v-tab-item>
          <StockAdjustmentFormDeduct :adjustmentType="'Deduct'" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle.vue";
import StockAdjustmentFormADD from "@/components/stocks/StockAdjustmentForm.vue";
import StockAdjustmentFormDeduct from "@/components/stocks/StockAdjustmentFormDeduct.vue";

export default {
  name: "StockAdjustment",
  components: { PageTitle, StockAdjustmentFormADD, StockAdjustmentFormDeduct },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>

<style scoped>
.tab {
  height: 80px;
}
</style>
